/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.PollResponse = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The PollResponse model module.
   * @module model/PollResponse
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>PollResponse</code>.
   * @alias module:model/PollResponse
   * @class
   */
  var exports = function() {
    var _this = this;







  };

  /**
   * Constructs a <code>PollResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PollResponse} obj Optional instance to populate.
   * @return {module:model/PollResponse} The populated <code>PollResponse</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('PollCategory')) {
        obj['PollCategory'] = ApiClient.convertToType(data['PollCategory'], 'Integer');
      }
      if (data.hasOwnProperty('PollQuestionType')) {
        obj['PollQuestionType'] = ApiClient.convertToType(data['PollQuestionType'], 'Integer');
      }
      if (data.hasOwnProperty('PollIdentifier')) {
        obj['PollIdentifier'] = ApiClient.convertToType(data['PollIdentifier'], 'Integer');
      }
      if (data.hasOwnProperty('PollAnswerNumber')) {
        obj['PollAnswerNumber'] = ApiClient.convertToType(data['PollAnswerNumber'], 'Integer');
      }
      if (data.hasOwnProperty('PollAnswer')) {
        obj['PollAnswer'] = ApiClient.convertToType(data['PollAnswer'], 'String');
      }
      if (data.hasOwnProperty('MicrosoftTeamsMemberID')) {
        obj['MicrosoftTeamsMemberID'] = ApiClient.convertToType(data['MicrosoftTeamsMemberID'], 'String');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} PollCategory
   * @default 0
   */
  exports.prototype['PollCategory'] = 0;
  /**
   * @member {Integer} PollQuestionType
   * @default 0
   */
  exports.prototype['PollQuestionType'] = 0;
  /**
   * @member {Integer} PollIdentifier
   * @default 0
   */
  exports.prototype['PollIdentifier'] = 0;
  /**
   * @member {Integer} PollAnswerNumber
   * @default 0
   */
  exports.prototype['PollAnswerNumber'] = 0;
  /**
   * @member {String} PollAnswer
   * @default ''
   */
  exports.prototype['PollAnswer'] = '';
  /**
   * @member {String} MicrosoftTeamsMemberID
   * @default ''
   */
  exports.prototype['MicrosoftTeamsMemberID'] = '';



  return exports;
}));


